import { useEffect, useRef } from 'react';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { setCompanyDetails } from 'store/common/slices/profile';
import { getErrorMessage } from 'utils/utilities';
import { useCreateTokenMutation, useVerifyCaptchaMutation } from 'features/onboarding';
import validationSchema from './OnboardingForm.validation';

const initialValues = {
    firstName: 'First',
    middleName: 'Middle',
    noMiddleName: false,
    lastName: 'Last',
    email: '',
    dob: '07/03/2003',
    accept: false,
    passcode: false,
    phoneNumber: '',
    countryCode: '1',
    captcha: '',
    verificationOption: 'EITHER',
};

export default function useOnboardingForm({ setToken }) {
    const dispatch = useDispatch();
    const captchaRef = useRef(null);
    const [createToken] = useCreateTokenMutation();
    const [verifyCaptcha] = useVerifyCaptchaMutation();

    useEffect(() => {
        dispatch(
            setCompanyDetails({
                company: { name: 'Authenticating.com' },
            })
        );
    }, [dispatch]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = '';
        };
        globalThis.addEventListener('beforeunload', handleBeforeUnload);
        globalThis.addEventListener('popstate', handleBeforeUnload);
        return () => {
            globalThis.removeEventListener('beforeunload', handleBeforeUnload);
            globalThis.removeEventListener('popstate', handleBeforeUnload);
        };
    }, []);

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setErrors, setSubmitting }) => {
            const d = new Date(values.dob);
            const dob = [
                ('0' + d.getDate()).slice(-2),
                ('0' + (d.getMonth() + 1)).slice(-2),
                d.getFullYear(),
            ].join('-');

            try {
                await verifyCaptcha(values.captcha).unwrap();
            } catch (error) {
                captchaRef.current?.reset();
                setSubmitting(false);
                setErrors({ captcha: 'Captcha verification failed. Please try again.' });
                return;
            }

            try {
                const result = await createToken({
                    email: values.email,
                    firstName: values.firstName,
                    middleName: values.middleName,
                    lastName: values.lastName,
                    dob,
                    phone: values.phoneNumber ? `+${values.phoneNumber}` : null,
                    verificationOption: values.verificationOption,
                }).unwrap();
                setSubmitting(false);
                setToken(result.token, {
                    email: values.email,
                    phone: `+${values.countryCode}${values.phoneNumber}`,
                });
            } catch (error) {
                toast.error(getErrorMessage(error));
                setSubmitting(false);
            }
        },
    });

    return { formik, captchaRef };
}
